import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import administrationContractorBasicInfo from "@/store/modules/administration/contractor/administrationContractorBasicInfo";
import administrationContractorsList from "@/store/modules/administration/contractor/administrationContractorsList";
import administrationContractorBankAccount from "@/store/modules/administration/contractor/administrationContractorBankAccount";
import administrationContractorPayerBankAccount from "@/store/modules/administration/contractor/administrationContractorPayerBankAccount";
import administrationContractorAdditionalSettings from "@/store/modules/administration/contractor/administrationContractorAdditionalSettings";
import administrationContractorExportAndIntegration from "@/store/modules/administration/contractor/administrationContractorExportAndIntegration";
import administrationContractorKsef from "@/store/modules/administration/contractor/administrationContractorKsefIntegration";
import administrationContractorCommissionsAndDiscounts from "@/store/modules/administration/contractor/AdministrationContractorCommissionsAndDiscounts";
import administrationContractorEditAttributes from "@/store/modules/administration/contractor/administrationContractorEditAttributes";
import administrationContractorCodes from "@/store/modules/administration/contractor/administrationContractorCodes";
import administrationContractorAutoInvoice from "@/store/modules/administration/contractor/administrationContractorAutoInvoice";
import administrationContractorMailNotification from "@/store/modules/administration/contractor/administrationContractorMailNotification";
import administrationContractorDocumentTemplate from "@/store/modules/administration/contractor/administrationContractorDocumentTemplate";
import administrationContractorCustomMailContentModule from "@/store/modules/administration/contractor/administrationContractorCustomMailContent";
import administrationContractorBranchModule from "@/store/modules/administration/contractor/administrationContractorBranch";
import administrationContractorStandingOrderModule from "@/store/modules/administration/contractor/administrationContractorStandingOrder";
import administrationContractorAttributeMappingModule from "@/store/modules/administration/contractor/administrationContractorAttributeMapping";

const AdministrationContractorsModule = defineModule({
  modules: {
    list: administrationContractorsList,
    basicInfo: administrationContractorBasicInfo,
    bankAccount: administrationContractorBankAccount,
    payerBankAccount: administrationContractorPayerBankAccount,
    additionalSettings: administrationContractorAdditionalSettings,
    exportAndIntegration: administrationContractorExportAndIntegration,
    commissionsAndDiscounts: administrationContractorCommissionsAndDiscounts,
    editAttributes: administrationContractorEditAttributes,
    contractorCodes: administrationContractorCodes,
    autoInvoice: administrationContractorAutoInvoice,
    mailNotification: administrationContractorMailNotification,
    documentTemplate: administrationContractorDocumentTemplate,
    customMailContent: administrationContractorCustomMailContentModule,
    branch: administrationContractorBranchModule,
    standingOrders: administrationContractorStandingOrderModule,
    mapping: administrationContractorAttributeMappingModule,
    ksef: administrationContractorKsef,
  },
  namespaced: true as const,
});

export default AdministrationContractorsModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AdministrationContractorsModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationContractorsModule);
